import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { User, Lock, ShieldCheck, Eye, EyeOff } from 'lucide-react';
import { API_URL } from '../config';
import './Login.css';

const Login = ({ onLogin }) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [errors, setErrors] = useState({ username: false, password: false });
    const navigate = useNavigate();

    // Lock body scroll for login page
    React.useEffect(() => {
        const originalStyle = {
            overflow: document.body.style.overflow,
            position: document.body.style.position,
            width: document.body.style.width,
            height: document.body.style.height
        };

        document.body.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.width = '100%';
        document.body.style.height = '100%';

        return () => {
            document.body.style.overflow = originalStyle.overflow;
            document.body.style.position = originalStyle.position;
            document.body.style.width = originalStyle.width;
            document.body.style.height = originalStyle.height;
        };
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        const newErrors = {
            username: !username.trim(),
            password: !password.trim()
        };
        
        setErrors(newErrors);

        if (newErrors.username || newErrors.password) {
            setError('กรุณากรอกข้อมูลให้ครบถ้วน');
            return;
        }

        setIsLoading(true);
        setError('');
        
        try {
            const response = await axios.post(`${API_URL}/api/login`, {
                username,
                password
            });

            if (response.data.token) {
                // Add a small delay for smooth transition feel
                setTimeout(() => {
                    onLogin(response.data.token, response.data.role, response.data.display_name || response.data.username);
                    navigate('/');
                }, 500);
            }
        } catch (err) {
            setError('Username หรือ Password ไม่ถูกต้อง');
            setIsLoading(false);
        }
    };

    return (
        <div className="login-page">
            <div className={`login-card ${error && !isLoading ? 'shake' : ''}`}>
                <div className="login-header">
                    <div className="login-logo-container">
                        <div className="login-logo-circle">
                            <ShieldCheck size={32} />
                        </div>
                    </div>
                    <h1 className="login-title">Parking Audit</h1>
                    <p className="login-subtitle">Sign in to manage your system</p>
                </div>

                {error && (
                    <div className="login-error">
                        {error}
                    </div>
                )}

                <form onSubmit={handleSubmit}>
                    <div className="input-group">
                        <label className="input-label">Username</label>
                        <div className={`input-wrapper ${errors.username ? 'error' : ''}`}>
                            <User size={18} className="input-icon" />
                            <input
                                type="text"
                                className="login-input"
                                value={username}
                                onChange={(e) => {
                                    setUsername(e.target.value);
                                    if (errors.username) setErrors({ ...errors, username: false });
                                }}
                                placeholder="Enter your username"
                                autoComplete="username"
                            />
                        </div>
                    </div>

                    <div className="input-group">
                        <label className="input-label">Password</label>
                        <div className={`input-wrapper ${errors.password ? 'error' : ''}`}>
                            <Lock size={18} className="input-icon" />
                            <input
                                type={showPassword ? "text" : "password"}
                                className="login-input"
                                value={password}
                                onChange={(e) => {
                                    setPassword(e.target.value);
                                    if (errors.password) setErrors({ ...errors, password: false });
                                }}
                                placeholder="••••••••"
                                autoComplete="current-password"
                            />
                            <button
                                type="button"
                                className="password-toggle"
                                onClick={() => setShowPassword(!showPassword)}
                                tabIndex="-1"
                            >
                                {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                            </button>
                        </div>
                    </div>

                    <button
                        type="submit"
                        className="login-button"
                        disabled={isLoading}
                    >
                        {isLoading ? 'Authenticating...' : 'Sign In'}
                    </button>
                </form>

                <div className="login-footer">
                    &copy; {new Date().getFullYear()} Parking Audit System
                </div>
            </div>
        </div>
    );
};


export default Login;

